import type { Theme } from "@mui/material";

export default function getCardOverrides(theme: Theme) {
  return {
    MuiCard: {
      styleOverrides: {
        root: {
          boxShadow: "none",
          borderRadius: theme.spacing(1.5), // 12px equivalent using theme spacing
        },
      },
    },
  };
}
